const LAST_PAYMENT_STATUS = {
    PENDING: 'PENDING',
    DONE: 'DONE',
    ERROR: 'ERROR'
  };
  
  export default LAST_PAYMENT_STATUS;
  